import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { t } from 'i18next';
import FilterTemplatesDialog from 'src/js/components/modals/filter-templates';
import siteSetup from 'src/js/modules/site-setup';
import dialogs from '..';

const { constants } = siteSetup;
const { siteSetupNames } = constants;

const getCaptions = () => ({
  title: t('Filter templates'),
  groupLabel: t('Business Category'),
  submitButtonLabel: t('Apply'),
});

const FilterTemplatesDialogContainer = ({
  control,
  contextData,
  resetData,
  resetForm,
  onSubmit = Function.prototype,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    contextData.businessCategory
      ? {
          label: contextData.businessCategory,
          value: contextData.businessCategorySlug,
          archetype: contextData.archetype,
        }
      : null
  );
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(!selectedOption);
  const dispatch = useDispatch();

  const captions = getCaptions();

  const closeDialog = useCallback(() => {
    if (submitButtonDisabled) {
      resetData();
      resetForm();
    }

    dispatch(dialogs.actions.hide());
  }, [submitButtonDisabled, resetData, resetForm, dispatch]);

  const handleSubmit = () => {
    onSubmit(selectedOption);
    closeDialog();
  };

  const controlSubmitButtonState = (value, businessCategoryValue) => {
    if (value && selectedOption && businessCategoryValue === selectedOption.label) {
      setSubmitButtonDisabled(false);
    } else if (!submitButtonDisabled) {
      setSubmitButtonDisabled(true);
    }

    return true;
  };

  const onCategorySelect = (option) => {
    setSelectedOption(option);
    setSubmitButtonDisabled(false);
  };

  useEffect(() => {
    setSubmitButtonDisabled(!selectedOption);
  }, [selectedOption]);

  useEffect(
    () => () => {
      if (!selectedOption) {
        resetForm();
      }
    },
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
    []
  );

  return (
    <FilterTemplatesDialog
      control={control}
      stepId={siteSetupNames.GALLERY}
      captions={captions}
      submitButtonDisabled={submitButtonDisabled}
      controlSubmitButtonState={controlSubmitButtonState}
      onCategorySelect={onCategorySelect}
      onInput={() => setSubmitButtonDisabled(true)}
      onSubmit={handleSubmit}
      onClose={closeDialog}
    />
  );
};

FilterTemplatesDialogContainer.propTypes = {
  control: PropTypes.shape({}).isRequired,
  contextData: PropTypes.shape({
    businessCategory: PropTypes.string,
    businessCategorySlug: PropTypes.string,
    archetype: PropTypes.string,
  }).isRequired,
  resetData: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default FilterTemplatesDialogContainer;
